module.exports = __webpack_public_path__ + "static/media/caixa.aa0cd7e9.png";